<template>
  <b-row>
    <b-col cols="6">
      <div style="display: block; margin: auto; height: 100%">
        <canvas ref="chart"></canvas>
      </div>
    </b-col>
    <b-col cols="6">
      <ListGroup :content="sectors" :colors="colors_list" />
    </b-col>
  </b-row>
</template>

<script>
import { Chart } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import ListGroup from "./ListGroup.vue";
export default {
  props: ["sectors"],
  components: {
    ListGroup
  },

  data() {
    return {
      colors_list: [
        "#9561E2",
        "#A574EC",
        "#B88EF6",
        "#E1CDFF",
        "#ECE0FF",
        "#F5F5F5"
      ],
      test: []
    };
  },
  mounted() {
    var ctx = this.$refs.chart.getContext("2d");
    var labels = [];
    var values = [];
    var colors = [];
    var color_index = 0;
    this.sectors.forEach(sector => {
      labels.push(sector.name);
      values.push(Math.round(sector.value, 0));
      colors.push(this.colors_list[color_index]);
      color_index++;
      if (color_index == this.colors_list.length) {
        color_index = 0;
      }
    });

    // eslint-disable-next-line no-unused-vars
    var myChart = new Chart(ctx, {
      plugins: [ChartDataLabels],
      type: "doughnut",
      data: {
        labels: labels,
        datasets: [
          {
            data: values,
            backgroundColor: colors,
            borderColor: "#121212",
            hoverBorderColor: "rgba(255, 255, 255, .87)",
            borderWidth: 0,
            hoverBorderWidth: 2,
            hoverOffset: 5
          }
        ]
      },
      options: {
        maintainAspectRatio: false,
        cutoutPercentage: 70,
        responsive: true,
        plugins: {
          datalabels: {
            color: "#ffffff",
            labels: {
              title: {
                font: {
                  weight: "bold",
                  size: "14px"
                }
              }
            },
            formatter: value => {
              return value + "%";
            }
          },
          legend: {
            display: false
          },
          tooltip: {
            position: "nearest",
            borderColor: "rgba(0, 0, 255, 1)",
            callbacks: {
              label: function(context) {
                return context.label;
              }
            }
          }
        }
      }
    });
  }
};
</script>